var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.has_settings
    ? _c("tr", { staticClass: "setting-tr" }, [
        _c(
          "td",
          { staticClass: "settings-cell", attrs: { colspan: "100" } },
          _vm._l(_vm.settings, function(setting) {
            return _c("SettingCell", {
              key: setting["Name"],
              attrs: { setting: setting }
            })
          })
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6038f16e", { render: render, staticRenderFns: staticRenderFns })
  }
}